export class Message {
  content;
  userType;

  constructor(content, userType) {
    this.content = content;
    this.userType = userType;
  }
}
